import homepageAxios from './homepageAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

export const domainHomepageHttpClient = toDomainHttpClient(homepageAxios, { forwardMeta: false })
